import { render, staticRenderFns } from "./ShowEventsForm.vue?vue&type=template&id=5b92fb20&scoped=true&"
import script from "./ShowEventsForm.vue?vue&type=script&lang=ts&"
export * from "./ShowEventsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ShowEventsForm.vue?vue&type=style&index=0&id=5b92fb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b92fb20",
  null
  
)

export default component.exports